import { render, staticRenderFns } from "./ModalFaq.vue?vue&type=template&id=c07c045c&scoped=true"
import script from "./ModalFaq.vue?vue&type=script&lang=js"
export * from "./ModalFaq.vue?vue&type=script&lang=js"
import style0 from "./ModalFaq.vue?vue&type=style&index=0&id=c07c045c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07c045c",
  null
  
)

export default component.exports